import moment from 'moment';
import i18next from 'i18next';
import { subDays, subMonths, subYears } from 'date-fns';

export function formatDateTime(date) {
  return moment(date).locale(i18next.language).format('DD MMM, YYYY HH:mm');
}

export function formatMonthTime(date) {
  return moment(date).locale(i18next.language).format('DD MMM, HH:mm');
}

export function formatMonth(date) {
  return moment(date).locale(i18next.language).format('DD MMM, YYYY');
}

export function formatTime(date) {
  return moment(date).format('HH:mm');
}

const DATE_QUERY_FORMAT = 'YYYY-MM-DD';

export const parseDateQuery = (dateString) => {
  const date = moment(dateString, DATE_QUERY_FORMAT);
  return dateString && date.isValid() ? date.toDate() : null;
};

export const formatDateQuery = (date) => {
  const value = moment(date);
  return date && value.isValid() ? value.format(DATE_QUERY_FORMAT) : null;
};

export const customDateRanges = [
  {
    label: 'Last Week',
    value: () => [subDays(new Date(), 7), new Date()],
  },
  {
    label: 'Last Month',
    value: () => [subMonths(new Date(), 1), new Date()],
  },
  {
    label: 'Last 3 Months',
    value: () => [subMonths(new Date(), 3), new Date()],
  },
  {
    label: 'Last 6 Months',
    value: () => [subMonths(new Date(), 6), new Date()],
  },
  {
    label: 'Last Year',
    value: () => [subYears(new Date(), 1), new Date()],
  },
];

export function getTimeRemaining(utcDateString) {
  const diff = new Date(utcDateString).getTime() - Date.now();

  if (!utcDateString || diff <= 0) {
    return { minutes: 0, seconds: 0 };
  }

  const totalSeconds = Math.floor(diff / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { minutes, seconds };
}

export const hasTimeLeft = (time) =>
  Boolean(time) && (time.minutes > 0 || time.seconds > 0);

export function formatTimeRemaining(timeRemaining) {
  if (!timeRemaining) return '00:00';

  const { minutes, seconds } = timeRemaining;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}
